import * as actionTypes from '../../actions/Admin/actionTypes'
const initState = {
    response: [],
    message: '',
}

export default (state = initState, action = {}) =>
{
    switch (action.type)
    {
        case actionTypes.ADMIN_CATEGORY_LIST_REQUEST:
            return {
                ...state,
                response: [],
                message: '',
            }
        case actionTypes.ADMIN_CATEGORY_LIST_SUCCESS:

            return {
                ...state,
                response: action.payload.data,
                message: 'Success',
            }
        case actionTypes.ADMIN_CATEGORY_LIST_ERROR:

            return {
                ...state,
                response: action.payload.response.data,
                message: 'Error',
            }
        case actionTypes.ADMIN_CATEGORY_ADD_REQUEST:
            return {
                ...state,
                response: [],
                message: '',
            }
        case actionTypes.ADMIN_CATEGORY_ADD_SUCCESS:

            return {
                ...state,
                response: action.payload.data,
                message: 'Success',
            }
        case actionTypes.ADMIN_CATEGORY_ADD_ERROR:

            return {
                ...state,
                response: action.payload.response.data,
                message: 'Error',
            } 
        case actionTypes.ADMIN_CATEGORY_UPDATE_REQUEST:
            return {
                ...state,
                response: [],
                message: '',
            }
        case actionTypes.ADMIN_CATEGORY_UPDATE_SUCCESS:

            return {
                ...state,
                response: action.payload.data,
                message: 'Success',
            }
        case actionTypes.ADMIN_CATEGORY_UPDATE_ERROR:

            return {
                ...state,
                response: action.payload.response.data,
                message: 'Error',
            }

        case actionTypes.ADMIN_CATEGORY_STATUS_CHANGE_REQUEST:
            return {
                ...state,
                responseStatus: [],
                message: '',
            }
        case actionTypes.ADMIN_CATEGORY_STATUS_CHANGE_SUCCESS:
            
            return {
                ...state,
                responseStatus: action.payload.data,
                message: 'Success',
            }
        case actionTypes.ADMIN_CATEGORY_STATUS_CHANGE_ERROR:

            return {
                ...state,
                responseStatus: action.payload.response.data,
                message: 'Error',
            }
        case actionTypes.ADMIN_CATEGORY_ORDER_CHANGE_REQUEST:
            return {
                ...state,
                responseOrder: [],
                message: '',
            }
        case actionTypes.ADMIN_CATEGORY_ORDER_CHANGE_SUCCESS:
            
            return {
                ...state,
                responseOrder: action.payload.data,
                message: 'Success',
            }
        case actionTypes.ADMIN_CATEGORY_ORDER_CHANGE_ERROR:

            return {
                ...state,
                responseOrder: action.payload.response.data,
                message: 'Error',
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Admin/Category.js